'use client';

import { Suspense } from 'react';
import RoleLoginContent from '@/components/auth/RoleLoginContent';

export default function PartnerLoginPage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background flex items-center justify-center"><div className="text-muted-foreground text-sm">Loading...</div></div>}>
      <RoleLoginContent
        role="supplier"
        roleLabel="Partner / Supplier"
        redirectPath="/supplier-portal"
        accentColor="cyan"
        description="WorldwayLuxe Partner Portal — supplier and merchant access"
        features={[
          { icon: '⬡', label: 'Booking Management', desc: 'View and manage bookings for your products' },
          { icon: '◈', label: 'Revenue Dashboard', desc: 'Settlements, commissions, and payouts' },
          { icon: '✦', label: 'Product Catalogue', desc: 'Manage your listings and availability' },
        ]}
      />
    </Suspense>
  );
}
